var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('LHHeader'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.path,scopedSlots:_vm._u([{key:"default",fn:function(ref){
var Component = ref.Component;
return [_c(Component,{tag:"component"})]}}])})],1),_c('LHSvg'),_c('PreFooter'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('Konami')],1),_c('LHFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }